import type { PDPClickEventProps } from '@/scopes/products/infrastructure/analytics'
import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { Button, tk, Typography } from '@sunwebgroup/ui-components'
import { isEmpty } from 'ramda'
import { styled } from 'styled-components'
import { RoomType } from './RoomType'
import { ShowMore } from './ShowMore'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Heading = styled(Typography)`
  margin-bottom: ${tk('spacing_lg')};
`

const ShowMoreRoomtypes = styled(ShowMore)`
  margin-bottom: ${tk('spacing_lg')};

  ${Button} {
    margin-top: ${tk('spacing_md')};
    width: auto;
  }
`

const AdditionalInfoHeading = styled(Typography)`
  margin-bottom: ${tk('spacing_xs')};
`

export function RoomTypes() {
  const roomTypes = useCMSPageField('PDP.roomTypes')
  const additionalInfoHtml = useCMSPageField('PDP.roomTypes.additionalInfoHtml')
  const intl = useIntl()

  const showMoreEvent: PDPClickEventProps = {
    element: 'Accordion',
    description: 'Show more room types',
    result: `Show all ${roomTypes.length} roomtypes`,
  }

  const showLessEvent: PDPClickEventProps = {
    element: 'Accordion',
    description: 'Show less room types',
    result: `Show less roomtypes`,
  }

  return (
    <Wrapper>
      <Heading $variant="heading-md">{intl.formatMessage({ id: 'roomtypes_heading' })}</Heading>
      {!isEmpty(roomTypes) && (
        <ShowMoreRoomtypes
          closeLabel={intl.formatMessage({ id: 'roomtypes_show_less_label' })}
          openLabel={intl.formatMessage({ id: 'roomtypes_show_more_label' }, { amount_roomtypes: roomTypes.length })}
          visibleItems={4}
          showMoreEvent={showMoreEvent}
          showLessEvent={showLessEvent}
        >
          {roomTypes.map(roomType => (
            <RoomType roomType={roomType} key={roomType.id} />
          ))}
        </ShowMoreRoomtypes>
      )}
      {additionalInfoHtml && (
        <>
          <AdditionalInfoHeading $variant="body-md-bold">
            {intl.formatMessage({ id: 'roomtypes_extra_info_label' })}
          </AdditionalInfoHeading>
          <Typography $variant="body-md" dangerouslySetInnerHTML={{ __html: additionalInfoHtml }} />
        </>
      )}
    </Wrapper>
  )
}
